import styled from "@emotion/styled";
import { alpha, Box, systemWidth } from "@kaltura/mediaspace-shared-styled";
import { Button, Typography } from "@kaltura/ds-react-components";
import { contrastTextShadow } from "@kaltura/mediaspace-shared-ui";

const sharedStyled = {
    maxWidth: 600,
};

export const StyledHeroUnit = styled(
    "div",
    {
        shouldForwardProp(propName) {
            return propName !== "isMobileLandscape" && propName !== "isClickable";
        },
    }
)<{ isMobileLandscape?: boolean; isClickable: boolean }>(({ theme, isMobileLandscape, isClickable }) => [
    {
        display: "block",
        position: "relative",
        width: "100%",
        color: theme.palette.common.white,
        height: "80vh",
        cursor: isClickable ? "pointer" : undefined,
        ".kms-ds-homepage-component-hero-unit-name": {
            color: theme.palette.common.white,
        },
        ...(
            isMobileLandscape && {
                height: "100vh",
            }
        ),
    },
]);

export const StyledBackDrop = styled("div")({
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    backgroundImage: "linear-gradient(to bottom, transparent 0%, #000)",
});

export const TitleWrapper = styled(
    "div",
    {
        shouldForwardProp(propName) {
            return propName !== "isMobileLandscape";
        },
    }
)<{ isMobileLandscape?: boolean }>(({ theme, isMobileLandscape }) => [
    {
        "&": systemWidth({ theme }),
        position: "absolute",
        left: 0,
        right: 0,
        top: isMobileLandscape ? 60 : 88,
    },
]);

export const Title = styled(Typography)(({ theme }) => ({
    color: theme.palette.common.white,
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        fontSize: theme.typography.pxToRem(32),
    },
    textShadow: contrastTextShadow,
}));

export const Content = styled("div")(({ theme }) => ({
    "&": systemWidth({ theme }),
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 36,
    [theme.breakpoints.up(theme.breakpoints.values.sm)]: {
        bottom: 40,
    },
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
        bottom: 60,
    },
}));

export const LiveLabel = styled(Box)(({ theme }) => ({
    display: "inline-block",
    color: theme.palette.common.white,
    backgroundColor: alpha(theme.palette.common.white, 0.2),
    textTransform: "uppercase",
    borderRadius: theme.kaltura.shape.roundness1,
    padding: theme.spacing(0.5),
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.kaltura.typography.fontWeightBold,
    letterSpacing: 1,
}));

export const Name = styled(Typography)(({ theme }) => ({
    ...sharedStyled,
    display: "block",
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        fontSize: theme.typography.pxToRem(32),
    },
    textShadow: contrastTextShadow,
}));

export const Description = styled("div")(({ theme }) => ({
    ...sharedStyled,
    marginTop: theme.spacing(2),
    fontSize: theme.typography.pxToRem(16),
    textShadow: contrastTextShadow,
}));

export const ButtonsWrapper = styled("div")(({ theme }) => ({
    marginTop: theme.spacing(3),
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        marginTop: theme.spacing(2),
    },
}));

export const TogglePlayButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(0.5),
    border: "none",
    float: "right",
    color: "translucent",
}));
